import { useTranslation } from "react-i18next";
import useMmcService from "../../services/MmcService";
import { useContext } from "react";
import InitContext from "../pages/InitContext";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import {Consts} from "../pages/consts";

const RequestDataDeleteDialog = ({
  showDialog,
  onConfirmRequestDataDelete,
  onCancelRequestDataDelete,
}) => {
  const { t: t } = useTranslation();

  const { loading, error, clearError, requestDbPatientDataDelete } =
    useMmcService();

  const context = useContext(InitContext);

  const handleRequestDataDelete = async () => {
    clearError();

    const res = await requestDbPatientDataDelete(
      context?.token,
      context?.patient?.id,
    );

    if (res) {
      onConfirmRequestDataDelete();
    } else {
      console.error("request patient data delete failed");
    }
  };

  const errorMessage = error && <ErrorMessage message={error} />;
  const spinner = loading && <Spinner />;

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-medium">
        <header className="w3-container w3-padding-small w3-center">
          <p>{t("request_delete_my_data")}</p>
        </header>
        {errorMessage}
        {spinner}
        <div className="w3-container w3-padding-small w3-margin-left">
          <label>
            {t("request_delete_my_data_info1")}{" "}
            {t("request_delete_my_data_info2")}{" "}
            {t("request_delete_my_data_info3")}
          </label>
          <label>{t("are_you_sure")}</label>
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5"
              onClick={handleRequestDataDelete}
            >
              {t("yes")}
            </button>
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={onCancelRequestDataDelete}
            >
              {t("no")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default RequestDataDeleteDialog;
